import React from "react";
import { BrowserRouter as Router, Routes, Route, } from "react-router-dom";
import Landing from "./screens/Landing.jsx";
import ServicePages from "./pages/ServicePages.jsx";
import TopNav from "./components/Nav/TopNavbar.jsx"; // or wherever your top nav is
import "@fontsource/poppins/400.css";

function Layout({ children }) {
  return (
    <>
      <TopNav />
      <main>{children}</main>
    </>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Landing />
          </Layout>
        }
      />
      <Route
        path="/servicepages/:id"
        element={
          <Layout>
            <ServicePages />
          </Layout>
        }
      />
      {/* Add more routes like /events, etc. */}
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
